module.exports = __webpack_public_path__ + "static/media/tab-ipsum-sample.e6dc09a7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/tab-ipsum-sample.gif
// module id = ./src/images/tab-ipsum-sample.gif
// module chunks = 0